import * as Types from '../types';
import { Environment } from '../../../config';
import request from '../../../utils/request';

/** fetchZonesList  */
export interface IZonesListOutput {
  items: IDataItems[];
  paging: IPaging;
}

export interface IDataItems {
  zone: string | null;
  zone_description: string | null;
  building_density: string | null;
  max_floors: string | null;
  max_height: string | null;
  max_coverage: string | null;
  zone_description_name: string | null;
}

interface IPaging {
  page: string;
  pageSize: string;
  total: number;
}

interface IZonesListInput {
  sortField?: string;
  page?: number;
  pageSize?: number;
  order?: 'asc' | 'desc';
}

export const fetchZonesList = async (
  payload?: IZonesListInput
): Promise<Types.ResponseOutput> => {
  let path = '';
  if (payload) {
    path = `${Environment.API_BASE_URL}/api/zones/list?page=${payload.page}&pageSize=${payload.pageSize}&sortField=${payload.sortField}&order=${payload.order}`;
  } else {
    path = `${Environment.API_BASE_URL}/api/zones/list`;
  }
  const { data }: any = await request('get', path);

  let _data: IZonesListOutput = data.data;
  let output: Types.ResponseOutput = {
    message: data.message,
    data: _data,
    status: data.status,
  };
  return output;
};

/** Zones Detail */
interface IZonesDetailInput {
  id: number;
}

interface IZonesDetailOutput extends Types.ResponseOutput {
  data: {
    zone: string | null;
    zone_description: string | null;
    building_density: string | null;
    max_floors: string | null;
    max_height: string | null;
    max_coverage: string | null;
    zone_description_name: string | null;
  };
}

export const fetchZonesDetail = async (
  payload: IZonesDetailInput
): Promise<IZonesDetailOutput> => {
  const { data }: any = await request(
    'get',
    `${Environment.API_BASE_URL}/api/zones/${payload.id}`
  );

  let output = {
    message: data.message,
    data: data.data,
    status: data.status,
  };
  return output;
};

/** Add Zones */
interface IZonesAddInput {
  zone: string | null;
  zone_description: string | null;
  building_density: string | null;
  max_floors: string | null;
  max_height: string | null;
  max_coverage: string | null;
  zone_description_name: string | null;
}

interface IZonesAddOutput extends Types.ResponseOutput {
  data: {};
}

export const addZones = async (
  payload: IZonesAddInput
): Promise<IZonesAddOutput> => {
  const { data }: any = await request(
    'post',
    `${Environment.API_BASE_URL}/api/zones `,
    { body: payload }
  );

  let output = {
    message: data.message,
    data: data.data,
    status: data.status,
  };
  return output;
};

/** Edit Zones */
interface IZonesEditInput {
  zone: string | null;
  zone_description: string | null;
  building_density: string | null;
  max_floors: string | null;
  max_height: string | null;
  max_coverage: string | null;
  zone_description_name: string | null;
}

interface IZonesEditOutput extends Types.ResponseOutput {
  data: {};
}

export const editZones = async (
  payload: IZonesEditInput
): Promise<IZonesEditOutput> => {
  const { data }: any = await request(
    'patch',
    `${Environment.API_BASE_URL}/api/zones `,
    { body: payload }
  );

  let output = {
    message: data.message,
    data: data.data,
    status: data.status,
  };
  return output;
};
